import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class configAutoLinker_template extends vnTemplate{

    protected domainsTooltip: infoButton_template;
    protected domainsTooltipContent;
    protected filterListingPageTemplate: filterListingPage_template;
    protected filterShowMoreListingPageTemplate: filterListingPage_template;
    protected affiliateNetworkFilter: multipleSelector_template;
    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;


    protected getTemplateHtml(): string{
        let myThis = this;
        return `
            <div class="list-header w-justify">
                <div class="w-left">
                    <button data-bind="event: { click: onClickCancelEdit }" class="btn secondary icon i-back" type="button">Go Back</button>
                </div>
            </div>
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title icon i-network">3rd Party Affiliation Services</h3>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group row">
                            <label for="sovrnId" class="form-label">Sovrn ID</label> 
                            <input class="input-text" type="text" data-bind="value: sovrnId" id="sovrnId" >
                        </div>
                        <div class="form-group row">
                            <label for="skimlinksId" class="form-label">Skimlinks ID</label> 
                            <input class="input-text" type="text" data-bind="value: skimlinksId" id="skimlinksId" >
                        </div>
                        
                    </div>
                    <div class="form-body">
                        <div class="form-group row">
                            <label for="howlId" class="form-label">Narrativ/Howl ID</label> 
                            <input class="input-text" type="text" data-bind="value: howlId" id="howlId" >
                        </div>
                    </div>
                </div>
                <div class="form-footer">
                    <button data-bind="event: {click: onClickCancelEditConfig}" class="btn " type="button">Cancel</button>
                    <button 
                        data-bind="event: {click: onClickSaveConfig}" 
                        class="btn highlight" type="button" >Save</button>
                </div>
            </div>
            
            
            <div class="w-form w-form-large" id="rules-container">
            
                <div class="form-header">
                    <h3 class="form-title icon i-t-option">Configured Autolinker Rules</h3>
                </div>
                
                <div class="list-header" style="border-bottom: 1px solid #d1d1d1;padding-bottom: 1rem;margin-bottom: 1rem;">
                
                    <div class="w-justify">
                    
                        <div class="w-left">
                            <div class="filter-larger">
                                ` + this.affiliateNetworkFilter.getHtmlBuild() + `
                            </div>                
                        </div>
                        
                        <div class="w-center">
                            <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                                <div class="w-search-feild icon i-search2">
                                    <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                                    <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                                    <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                                    <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                                </div>
                            </div>
                        </div>
    
                        <div class="w-right">
                            <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                                <div class="pagination">
                                    <input data-bind="value: pageNumber" type="hidden" value="1">
                                    <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                                    <ul data-bind="foreach: pages">
                                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>
        
                                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>
        
                                        <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                                    </ul>
                                    <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected" >
                        <div id="selected-networks"></div>
                    </div>
                </div> 
                
                <div id="list-results">
                    <table class="list-results">
                        ` + this.resultInfos.getHtmlBuild() + `
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'partner.name') }, css: { 'list-sort-desc': orderByAndDirection()=='partner.name_DESC', 'list-sort-asc': orderByAndDirection()=='partner.name_ASC' }">Affiliate Network</span></th>
                                <th style="display: flex;margin-top: 1.25rem;">
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'domain.domain') }, css: { 'list-sort-desc': orderByAndDirection()=='domain.domain_DESC', 'list-sort-asc': orderByAndDirection()=='domain.domain_ASC' }">Targeted Domains</span>
                                    <div class="w-tooltips-adv pos-bottom short">
                                        ` + this.domainsTooltip.getHtmlBuild() + `
                                    </div>
                                </th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'domain.rule') }, css: { 'list-sort-desc': orderByAndDirection()=='domain.rule_DESC', 'list-sort-asc': orderByAndDirection()=='domain.rule_ASC' }">URL Result Rule</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'domain.isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='domain.isActive_DESC', 'list-sort-asc': orderByAndDirection()=='domain.isActive_ASC' }">Active</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: ruleList">
                            <tr>
                                <td><span data-bind="text: partnerName"></span></td>
                                <td><span data-bind="text: domain"></span></td>
                                <td><span data-bind="text: rule"></span></td>
                                <td>
                                    <div class="form-check-inline" style="margin-bottom: 1rem">
                                        <input type="checkbox" data-bind="checked: isActive, attr:{id: 'is-active-' + id}">
                                        <label class="form-label icon i-check" data-bind="attr:{for: 'is-active-' + id}" ></label>
                                    </div>
                                </td>                        
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                 <div class="form-footer">                
                    <button data-bind="event: { click: onClickCancelEditRules }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSaveRules }" class="btn highlight" type="button">Save</button>            
                </div>
            </div>
        `;

    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.affiliateNetworkFilter = new multipleSelector_template("affiliateNetworkFilter", this.getTemplateViewModel(), this.caller);
        this.affiliateNetworkFilter.setLabel("Affiliate Networks");
        this.affiliateNetworkFilter.setFilterContainerClass('margin-neg');
        this.affiliateNetworkFilter.setTagContainerId('selected-networks');
        this.affiliateNetworkFilter.setTagContainerCaption('Selected networks:');

        this.filterListingPageTemplate = new filterListingPage_template("filterListingPageTemplate", this.getTemplateViewModel(), this.caller);
        this.filterListingPageTemplate.setPlaceholder("Main Hub Page");

        this.filterShowMoreListingPageTemplate = new filterListingPage_template("filterShowMoreListingPageTemplate", this.getTemplateViewModel(), this.caller);
        this.filterShowMoreListingPageTemplate.setPlaceholder('Show More Hub Page');

        // Tooltip
        this.domainsTooltipContent = `
        <p>The <strong>Target Domains</strong> are used to make partial matches with URLs that appear in article content.</p>
        <p>If the <strong>Affiliate Link</strong> contains text in target domains column, then Automatic Affiliation will apply.</p>
        <ul>
        <li>Example</li>
        <li>Target Domain = "amazon.com"</li>
        <ul>
        <li>https://www.amazon.com/dp/B0B1QH5TS3/ WILL be auto affiliated</li>
        <li>https://www.amazon.ca/dp/B0B1QH5TS3 WILL NOT be auto affiliated</li>
        </ul>
        </ul>
        `;
        this.domainsTooltip = new infoButton_template('domainsTooltip', this.getTemplateViewModel(), this.caller)
        this.domainsTooltip.setTitle('Target Domains');
        this.domainsTooltip.setContent(this.domainsTooltipContent);

    }

    protected getTemplateName(): string{
        return "configAutoLinker-template";
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            sovrnId: ko.observable(""),
            skimlinksId: ko.observable(""),
            howlId: ko.observable(""),
            ruleList: ko.observableArray([]),
            orderBy: ko.observable("partner.name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("partner.name_ASC"),
            onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();
            },
            onClickCancelEditRules: function (data, event) {
                self.onClickCancelEditRules();
            },
            onClickCancelEditConfig: function (data, event) {
                self.onClickCancelEditConfig();
            },
            onClickSaveConfig: function (data, event) {
                self.onClickSave('config')
            },
            onClickSaveRules: function (data, event) {
                self.onClickSave('rules')
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            }
        };
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public setAutoLinkerConfig(config): void {

        // @TODO safely replace the following with a dynamic list of observables that include a generalConfig_ prefix?? ex.:
        /*if (config !== null) {
            for (let property in config) {
                if (config.hasOwnProperty(property)) {
                    let viewModelProperty = 'generalConfig_' + property;
                    if (typeof this.getTemplateViewModel()[viewModelProperty] === 'function') {
                        this.getTemplateViewModel()[viewModelProperty](config[property]);
                    }
                }
            }
        }*/

        if (config !== null) {

            this.getTemplateViewModel().sovrnId(config.sovrnId);
            this.getTemplateViewModel().skimlinksId(config.skimlinksId);
            this.getTemplateViewModel().howlId(config.howlId);
        }
    }

    public setAutoLinkerDomainRules(domains): void {

        let updatedRuleList = [];

        if (domains && domains.length > 0) {
            domains.forEach((rule) => {
                let modifiedRule = rule.rule;
                if (rule.partner.config && rule.partner.config.length > 0) {
                    rule.partner.config.forEach((configItem) => {
                        const placeholder = "{" + configItem.name + "}";
                        modifiedRule = modifiedRule.replace(placeholder, configItem.value); // replace config placeholders with their corresponding values
                    });
                }
                updatedRuleList.push({
                    partnerName: rule.partner.name,
                    domain: rule.domain,
                    rule: modifiedRule,
                    isActive: rule.isActive,
                    id: rule.id
                });
            });
        }

        this.getTemplateViewModel().ruleList(updatedRuleList);

    }

    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword
                , partnerIds : this.getTemplateViewModel().affiliateNetworkFilter.selectedItems
            },
        }
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickCancelEditRules(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickCancelEditConfig(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(section): any {
        this.caller.save(section);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/configAutoLinker_template.ts